<template>
  <b-modal
    ref="quickReplyModal"
    :title="`${replyGiven ? 'Edit': 'Create'} Quick Reply`"
    modal-class="quick-reply-modal"
    hide-footer
    size="md"
    :static="true"
    @shown="autoFocus"
    @hidden="resetData">
    <div>
      <div class="text-message">
        <div class="keyword-input">
          <span class="slash">/</span>
          <b-input
            ref="keywordInput"
            v-model="keyword"
            v-validate="'required'"
            name="keyword"
            type="text"
            data-vv-as="Keyword"
            placeholder="Add Keyword"
            @keydown.native="preventSpace"/>
          <span
            v-if="errors.has('keyword')"
            class="validation-error">{{ errors.first('keyword') }}</span>
          <span
            v-if="validationErrors.keyword"
            class="validation-error">{{ validationErrors.keyword }}</span>
        </div>
        <div>
          <MessageTextArea
            ref="messageArea"
            :enter-submit="false"
            class="mt-3"
            placeholder="Enter text here..."/>
        </div>
        <span
          v-if="validationErrors.text"
          class="validation-error">{{ validationErrors.text }}</span>
      </div>
      <b-button
        :class="{loading: saving}"
        :disabled="saving"
        class="btn-round btn-block mt-4 mb-3"
        @click="saveReply">
        <span v-if="!saving">Save</span>
        <div class="loader"><div class="loading-circle"/></div>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import setValidationErrors from '@/helpers/validationErrors';
import MessageTextArea from '../../../common/MessageTextArea';

export default {
  name: 'QuickReplyModal',
  components: {
    MessageTextArea,
  },
  data() {
    return {
      reply: {},
      keyword: '',
      replyGiven: false,
      saving: false,
      validationErrors: {},
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters({
      quickReplyCreated: 'chat/quickReplyCreated',
      quickReplyUpdated: 'chat/quickReplyUpdated',
      apiError: 'chat/apiError',
    }),
  },
  watch: {
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
    quickReplyCreated(created) {
      if (created) {
        this.$emit('replySaved', true);
        this.hide();
      }
    },
    quickReplyUpdated(updated) {
      if (updated) {
        this.$emit('replySaved', true);
        this.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      createQuickReply: 'chat/createQuickReply',
      updateQuickReply: 'chat/updateQuickReply',
    }),
    show() {
      this.$refs.quickReplyModal.show();
    },
    hide() {
      this.resetData();
      this.$refs.quickReplyModal.hide();
    },
    autoFocus() {
      this.$refs.keywordInput.focus();
    },
    setReply(reply) {
      this.reply = reply;
      this.keyword = reply.keyword;
      this.replyGiven = true;
      this.$refs.messageArea.setText(reply.text);
    },
    preventSpace(e) {
      if (e.which === 32) {
        e.preventDefault();
      }
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$refs.messageArea.clear();
    },
    saveReply() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.saving = true;
          const replyData = {
            keyword: this.keyword,
            text: this.$refs.messageArea.getText(),
          };

          if (this.replyGiven) {
            this.updateQuickReply({
              merchant_id: this.$route.params.merchant_id,
              reply_id: this.reply.id,
              data: replyData,
            });
          } else {
            this.createQuickReply({
              merchant_id: this.$route.params.merchant_id,
              data: replyData,
            });
          }
        }
      });
    },
  },
};
</script>
